module.exports = __webpack_public_path__ + "static/media/riz-carotte-feve.d564aa3a.png";